"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var openvidu_browser_1 = require("openvidu-browser");
var models_1 = require("../models");
var media_devices_service_1 = require("./media-devices.service");
var webrtc_service_1 = require("./webrtc.service");
var network_service_1 = require("./network.service");
var WebrtcServiceImpl = /** @class */ (function (_super) {
    __extends(WebrtcServiceImpl, _super);
    function WebrtcServiceImpl(devices, network) {
        var _this = _super.call(this) || this;
        _this.devices = devices;
        _this.network = network;
        return _this;
    }
    WebrtcServiceImpl.prototype.initialize = function (roomId) {
        this.ov = new openvidu_browser_1.OpenVidu();
        this.session = this.ov.initSession();
        this.account = new models_1.LocalAccount(this.session.connection, roomId);
    };
    WebrtcServiceImpl.prototype.joinToRoom = function (roomId) {
        return __awaiter(this, void 0, void 0, function () {
            var connection;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.network.createConnection(roomId)];
                    case 1:
                        connection = _a.sent();
                        if (!connection) return [3 /*break*/, 3];
                        this.account.connection = connection;
                        return [4 /*yield*/, this.session.connect(connection.token)];
                    case 2:
                        _a.sent();
                        this.account.join(connection.connectionProperties.role);
                        _a.label = 3;
                    case 3: return [2 /*return*/, connection.connectionProperties.data ? JSON.parse(connection.connectionProperties.data) : null];
                }
            });
        });
    };
    WebrtcServiceImpl.prototype.disconnect = function () {
        if (this.account.manager && this.account.manager.stream && this.account.manager.stream.getMediaStream() &&
            this.account.manager.stream.getMediaStream().getTracks()) {
            this.account.manager.stream.getMediaStream().getTracks().forEach(function (track) {
                track.stop();
            });
        }
        this.session.disconnect();
    };
    WebrtcServiceImpl.prototype.createPublisher = function (config) {
        this.account.manager && this.unPublish();
        this.account.setManager(this.ov.initPublisher(void 0, config));
    };
    WebrtcServiceImpl.prototype.publish = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.session.publish(this.account.manager)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebrtcServiceImpl.prototype.unPublish = function () {
        this.session.unpublish(this.account.manager);
    };
    WebrtcServiceImpl.prototype.stopShowing = function (participant) {
        participant.setManager(null);
    };
    WebrtcServiceImpl.prototype.startShowing = function (stream, participant) {
        return __awaiter(this, void 0, void 0, function () {
            var manager;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isMyOwnConnection(stream.connection)) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.session.subscribe(stream, undefined)];
                    case 1:
                        manager = _a.sent();
                        participant.setManager(manager);
                        return [2 /*return*/];
                }
            });
        });
    };
    WebrtcServiceImpl.prototype.isMyOwnConnection = function (connection) {
        return connection.connectionId === this.session.connection.connectionId;
    };
    WebrtcServiceImpl.prototype.on = function (type, handler) {
        return this.session.on(type, handler);
    };
    WebrtcServiceImpl.prototype.getAccount = function () {
        return this.account;
    };
    WebrtcServiceImpl.prototype.signal = function (data, to, type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.session.signal({ data: data, to: to, type: type })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WebrtcServiceImpl = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [media_devices_service_1.MediaDevicesService,
            network_service_1.NetworkService])
    ], WebrtcServiceImpl);
    return WebrtcServiceImpl;
}(webrtc_service_1.WebRTCService));
exports.WebrtcServiceImpl = WebrtcServiceImpl;
//# sourceMappingURL=webrtc.service.impl.js.map